import { TransferRequestListPage } from "@/features/transfer-request/pages/TransferRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-request/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.view_outgoing"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferRequestListPage,
});
